export interface IColor {
  name: string;
  en_name: string;
  hex: string;
}

export default function colorMap(): IColor[] {
  return [
    {
      name: 'سفید',
      en_name: 'white',
      hex: '#f5f5f5',
    },
    {
      name: 'مشکی',
      en_name: 'black',
      hex: '#181818',
    },
    {
      name: 'طلایی',
      en_name: 'gold',
      hex: '#c99212',
    },
    {
      name: 'آبی',
      en_name: 'blue',
      hex: '#0000ff',
    },
    {
      name: 'نقره ای',
      en_name: 'silver',
      hex: '#dedede',
    },
    {
      name: 'نوک مدادی',
      en_name: 'pengray',
      hex: '#696969',
    },
    {
      name: 'بژ',
      en_name: 'bej',
      hex: '#d9c6b8',
    },
    {
      name: 'آبی نفتی',
      en_name: 'oilblue',
      hex: '#10265b',
    },
  ];
}
